import styled from '@emotion/styled';
import { Colors } from '../../../../../colors';
import { Grid } from '@mui/material';

export const FOOTER_HEIGHT = 65
export const FooterBookingStyled = {
  Container: styled(Grid)<any>`
   display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${Colors.White};
    padding: 9px 45px;
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 100;
    height: ${FOOTER_HEIGHT}px;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
  `,
  ContainerDescription: styled(Grid)<any>`
  `,
  ContainerButton: styled(Grid)<any>`
  `,
  Description: styled.p<any>`
    font-family: EncodeSans-SemiBold;
    font-size: 16px;
  `,
};
